module.exports = __webpack_public_path__ + "media/src/images/icons/file_types/pptx-0da70a061775971782fd8a655f1de4b6.svg";